export const environment = {
  apiUrl: 'https://a00o4bi693.execute-api.us-west-2.amazonaws.com/dev',
  apiName: 'jjaaapi',
  apiPaths: {
    products: '/products',
    adminUsers: '/adminUsers',
    stepPermissions: '/adminUsers/permissions',
    images: '/images',
    partnumber: '/partnumber',
    attachments: '/attachments'
  }
}
